import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step9 } from '../../../../../shared/models/component-messages/formfnsimplerectificatif/step9';
import { Rectificatif } from '../../models/Rectificatif';
import { ArrayPopTools } from '../../../../../shared/services/array-pop-tools';

@Component({
  selector: 'app-step9',
  templateUrl: './step9.component.html'
})
export class Step9Component implements OnInit {

  @Input() rectificatif: Rectificatif;
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;



	@Input() uid = '';
  @Input() linkForRouter: string;
  public step9 = new Step9();

	constructor() { }


  ngOnInit(): void {
    if(this.rectificatif === undefined || this.rectificatif === null) {
      this.rectificatif = new Rectificatif();

    }
    else if (this.rectificatif.infosRectif === null || this.rectificatif.infosRectif.length === 0) {
    this.rectificatif.infosRectif = [];
    this.rectificatif?.infosRectif.push(new String());
    }
  }

  public getUid() {
		return this.uid;
	}

  public addInfoRectif() {
   this.rectificatif?.infosRectif.push(new String());
  }

  public removeInfo(i){
    ArrayPopTools.pop(this.rectificatif?.infosRectif, i, this.parentForm, this.getUid());
  }

}
